
const DocumentViewerComponent = ({fileUrl}) => {
    const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;

    return (
        <iframe
            src={viewerUrl}
            style={{ width: '100%', height: '600px', border: 'none'}}
            title="Document Viewer" />
    );
};

export default DocumentViewerComponent;